import request from '@/utils/request'


//查询课程接口
export function gitCourseList(params) {
    return request({
        url: '/hdjg/course/page',
        method: 'get',
        params
    })
}

/**
 * 获取公告列表
 *
 * 该函数通过发送GET请求到'/hdjg/notice/page'端点，获取分页的公告信息
 * 主要用于在前端界面展示公告列表
 *
 * @param {Object} params - 请求参数对象，通常包含分页信息和筛选条件
 * @returns {Promise} - 返回一个Promise对象，包含请求的响应数据
 */
export function gitNoticeList(params) {
    return request({
        url: '/hdjg/notice/page',
        method: 'get',
        params
    })
}



/**
 * 根据ID获取Git通知
 *
 * 此函数通过发送GET请求到特定的URL，以获取与给定ID相关的Git通知
 * 它主要用于获取通知的详细信息，以便进一步处理或显示
 *
 * @param {string} id - 通知的唯一标识符
 * @returns {Promise} 返回一个Promise对象，它在请求成功时解析为包含通知信息的对象，在请求失败时解析为错误对象
 */
export function gitNoticeById(id) {
    return request({
        url: '/hdjg/notice/get?id=' + id,
        method: 'get'
    })
}

